import {combineReducers} from 'redux'

import {forms} from '.'
import {offlinePaymentForm} from '../modules/offlinePayment/reducers'
import {formInputData} from './formInputs'

/**
 * This is the root reducer, the one that will construct the root state from
 * the combination of the other specific reducers the application will be
 * composed by.
 */
export default combineReducers({
    offlinePaymentForm,
    forms,
    formInputData
  })
